import * as v from "valibot";
import { rpcContract } from "../rpc";

export const resolveEmailContentRpcContract = rpcContract({
  name: "resolve-email-content",
  paramsSchema: v.object({
    template: v.string(),
    metadata: v.record(v.string(), v.unknown()),
    variables: v.record(v.string(), v.unknown()),
  }),
  resultSchema: v.union([
    v.object({
      status: v.literal("ok"),
      variables: v.record(v.string(), v.unknown()),
      subject: v.optional(v.string()),
    }),
    v.object({
      status: v.literal("gone"),
      reason: v.optional(v.string()),
    }),
  ]),
});

export type ResolveEmailContentParams = v.InferOutput<(typeof resolveEmailContentRpcContract)["paramsSchema"]>;
export type ResolveEmailContentResult = v.InferOutput<(typeof resolveEmailContentRpcContract)["resultSchema"]>;
